<template>
  <div>
    <v-textarea
      :class="classes"
      outlined
      v-bind="$attrs"
      v-on="$listeners"
    >
      <slot
        v-for="(_, name) in $slots"
        :slot="name"
        :name="name"
      />

      <template
        v-for="(_, name) in $scopedSlots"
        :slot="name"
        slot-scope="slotData"
      >
        <slot
          :name="name"
          v-bind="slotData"
        />
      </template>
    </v-textarea>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Textarea extends Vue {
  @Prop({ type: Boolean, default: false })
  blue_icon!: boolean;

  @Prop({ type: Boolean, default: false })
  require!: boolean;

  get classes() {
    return [
      'text-field',
      { blue_icon: this.blue_icon },
      { require: this.require },
    ];
  }
}
</script>

<style lang="scss" src="../inputs.scss" />
